
import { defineComponent } from 'vue';

/**
 * Icone de Loading
 * @displayName IconLoading [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconLoading',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
